import React, { useEffect, useMemo, useState } from 'react';
import './InstallPrompt.css';

const STORAGE_KEY = 'demarcheur-install-dismissed';

function isStandalone() {
  return window.matchMedia?.('(display-mode: standalone)').matches || window.navigator.standalone === true;
}

export default function InstallPrompt() {
  const [installEvent, setInstallEvent] = useState(null);
  const [visible, setVisible] = useState(false);
  const [iosInfo, setIosInfo] = useState(false);

  const isMobile = useMemo(() => /Android|iPhone|iPad|iPod/i.test(navigator.userAgent), []);

  useEffect(() => {
    if (!isMobile || isStandalone() || localStorage.getItem(STORAGE_KEY) === '1') return;

    const isiOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
    if (isiOS) {
      const timer = setTimeout(() => {
        setIosInfo(true);
        setVisible(true);
      }, 1800);
      return () => clearTimeout(timer);
    }

    const onBeforeInstallPrompt = (event) => {
      event.preventDefault();
      setInstallEvent(event);
      setVisible(true);
    };

    window.addEventListener('beforeinstallprompt', onBeforeInstallPrompt);
    return () => window.removeEventListener('beforeinstallprompt', onBeforeInstallPrompt);
  }, [isMobile]);

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, '1');
    setVisible(false);
  };

  const install = async () => {
    if (!installEvent) return;
    installEvent.prompt();
    await installEvent.userChoice.catch(() => null);
    setInstallEvent(null);
    dismiss();
  };

  if (!visible) return null;

  return (
    <div className="install-prompt" role="region" aria-label="Installer Démarcheur">
      <img src="/brand/app-icon.png" alt="" loading="lazy" decoding="async" />
      <div className="install-prompt-text">
        <strong>Installer Démarcheur</strong>
        <span>{iosInfo ? 'Sur iPhone : Partager, puis Ajouter à l’écran d’accueil.' : 'Accédez au site comme une application mobile.'}</span>
      </div>
      {installEvent && <button type="button" onClick={install}>Installer</button>}
      <button type="button" className="install-prompt-close" onClick={dismiss} aria-label="Fermer">x</button>
    </div>
  );
}
